import util from '@bmp-vue/core/api/util'

const controller = 'IdentityResource'
export default Object.assign({}, util.GetCrud(controller, null))
